import { useLocation } from "react-router-dom";
import { Modal, Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

export const ResetPasswordExpiryBox = () => {
    const handleOkClick = () => {
        window.location.href = "/";
    };
    const location = useLocation()
    const isEmail = location.pathname.includes("/email-verification")
    return (
        <Modal centered={true} isOpen={true} >
            <ModalHeader>
            Token Expired
            </ModalHeader>
            <ModalBody className="d-flex justify-content-start align-items-start">
            {isEmail ? 'Email Verification' : 'Reset Password'} Token Expired Please Generate new Token.
            </ModalBody>
            <ModalFooter className="d-flex justify-content-end">
                <Button color="secondary" onClick={handleOkClick} >Login</Button>
            </ModalFooter>
        </Modal>
    )
}
